import apiClient from "../apiClient";
import React from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const TransactionTypesUpdate = () => {
    const [transactiontype, setTransactionType] = useState({
        Description: "",
        });

    const [error, setError] = useState(false)

    const navigate = useNavigate();
    const location = useLocation();

    const transactiontypeId = location.pathname.split("/")[2]

    const handleChange = (e) => {
        setTransactionType((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        }

    const handleClick = async(e) => {
        e.preventDefault();
        if (!transactiontype.Description?.trim()) return setError(true);
        try {
            await apiClient.put("/transactiontypes/" + transactiontypeId, transactiontype);
            navigate("/TransactionTypes");
        } catch (err) {
            console.log(err);
            setError(true)
        }
     };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Update Transaction Type</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/TransactionTypes">Transaction Types</Link> / Update</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="transaction-type-description">Description</label>
                    <input
                        id="transaction-type-description"
                        type="text"
                        placeholder="Transaction Type Description"
                        name="Description"
                        onChange={handleChange}
                    />
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Update Type</button>
                        <Link className="btn-link" to="/TransactionTypes">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not update transaction type. Check input and try again.</p>}
                </div>
            </section>
        </div>
         );
    };

export default TransactionTypesUpdate;
